import angular from 'angular';
import multiLoanCqpModal from './multiLoanCqpModal';

export default angular
  .module('components.multiLoanCqpModal', [])
  .component('multiLoanCqpModal', multiLoanCqpModal).name;
